import React from 'react';
import Item from "../../components/list/Item";
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">
      <Meta
        title="A Philosophy Of Software Design"
        desc="A deep dive on how to solve complexity when creating software"
        keyword="philosophy, software, design, book, john ousterhout"
        image="/images/books/a-philosophy-of-software-design.jpg"
        pageType="book"
        author="John Ousterhout"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/a-philosophy-of-software-design.jpg"
                alt="a philosophy of software design engineering book"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                A Philosophy Of Software Design
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>John Ousterhout</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                This is a book that every person building software should read. It talks about how to Design Software and how important this phase is.
                Why is it important? Because it's the way to reduce the complexity of a system, specially, when the system is big or there are a lot of
                people working with it.
              </p>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                This book has been written by a professor who teaches Software Design in the Stanford University. A person who sees more than 90 solutions
                every year to the same problem. This is something that it's not happening in the corporate world.
              </p>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Some of the highlights of book.
              </p>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                - Tactical vs strategic coding.
              </p>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                - Deep vs shallow modules.
              </p>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                - Designing things twice: An interesting approach for finding the best design possible is to compare
                more than one solution.
              </p>

              <h2 className="text-jacarta-700 dark:text-white text-lg leading-normal mb-5 mt-10">
                <strong>About John Ousterhout</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                John is professor of Computer Science in Stanford University since 2008.
              </p>

              <h2 className="text-jacarta-700 dark:text-white text-lg leading-normal mb-5 mt-12">
                <strong>A book suggested for</strong>
              </h2>
              <Item
                title=""
                description="This is a book for everyone that work creating software. It does not matter how much experience
                you have, you will find value when reading this book."
              />
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
